import { render } from "./ToggleSwitch.vue?vue&type=template&id=59f35350&scoped=true"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=59f35350&scoped=true&lang=css"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f35350"]])

export default __exports__